"use strict";
/**
 * Compinent: Capçalera
 * Fitxer: AppHeader.tsx
 * Llenguatge: TypeScrypt
 * Autors: Jordi Riu
 * Versió: 1.1
 * Data: 11/04/2017
 * (c) Ajuntament de Manresa - abr 2017 - Departament de Sistemes d'Informació
 */

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var core_1 = require("@material-ui/core");

var mobx_react_1 = require("mobx-react");

var AppProgress_1 = require("./AppProgress");

var indigo_1 = require("@material-ui/core/colors/indigo");

var react_1 = require("react");

var useMediaQuery_1 = require("@material-ui/core/useMediaQuery");

var AppSessionInfo_1 = require("./AppSessionInfo");

var logoBlanc = require('../img/logoBlanc.svg'); // TODO: mirar alternatives: webpack? require.resolve? import?


if (typeof logoBlanc !== 'string' && logoBlanc.default) {
  logoBlanc = logoBlanc.default;
} // Estils


var useStyles = core_1.makeStyles(core_1.createStyles({
  chipVersioRoot: {
    display: 'inline-block',
    width: 'auto',
    height: 16,
    marginTop: -2,
    fontSize: 10,
    marginLeft: 4,
    cursor: 'pointer'
  },
  chipVersioLabel: {
    lineHeight: '16px',
    fontSize: 10,
    paddingLeft: 6,
    paddingRight: 6
  },
  chipEntornRoot: {
    width: 'auto',
    height: 20,
    marginTop: -2,
    color: '#FFF'
  },
  chipEntornLabel: {
    lineHeight: '20px',
    fontSize: 14,
    paddingLeft: 6,
    paddingRight: 6
  }
}));

var ChipEntorn = function ChipEntorn(props) {
  var classes = useStyles({});
  var backgroundColor = '';

  switch (props.entorn) {
    case 'Desenvolupament':
      backgroundColor = core_1.colors.deepOrange[600];
      break;

    case 'Proves':
      backgroundColor = core_1.colors.amber[600];
      break;

    case 'Preproducció':
      backgroundColor = core_1.colors.lime[600];
      break;

    default:
      return null;
  }

  return React.createElement(core_1.Chip, {
    label: props.entorn,
    style: {
      backgroundColor: backgroundColor
    },
    classes: {
      root: classes.chipEntornRoot,
      label: classes.chipEntornLabel
    }
  });
}; // Chip Nova Versió


var ChipNovaVersio = function ChipNovaVersio() {
  var classes = useStyles({});
  return React.createElement(core_1.Chip, {
    label: "Nova versi\xF3",
    color: "secondary",
    classes: {
      root: classes.chipVersioRoot,
      label: classes.chipVersioLabel
    }
  });
};

var AppHeader = function AppHeader(props) {
  var theme = core_1.useTheme();
  var upXs = useMediaQuery_1.default(theme.breakpoints.up('xs'));
  var upSm = useMediaQuery_1.default(theme.breakpoints.up('sm'));
  var landscape = useMediaQuery_1.default('(orientation: landscape)');

  var appState = props.appState,
      others = __rest(props, ["appState"]);

  react_1.useEffect(function () {
    if (appState) {
      appState.pantState.setHasHeader();
      appState.pantState.setHeaderHeight(getHeight());
    }
  });

  var getHeight = function getHeight() {
    return upSm ? 64 : upXs && landscape ? 48 : 56;
  };

  if (!appState) {
    return null;
  }

  var pantState = appState.pantState,
      versState = appState.versState,
      menuState = appState.menuState,
      config = appState.config;

  var handleClickSubtitol = function handleClickSubtitol() {
    if (config.subtitol && config.showVersions) {
      pantState.goPantalla('/versions');
    }
  };

  var colorSubT = indigo_1.default[200];
  var leftButton = menuState.hiHaDrawer ? React.createElement(core_1.Tooltip, {
    title: "Men\xFA"
  }, React.createElement(core_1.IconButton, {
    style: {
      padding: 0
    },
    onClick: appState.menuState.toogleDrawer
  }, React.createElement("img", {
    style: {
      height: 40
    },
    src: logoBlanc,
    alt: "Ajuntament de Manresa"
  }))) : React.createElement("img", {
    style: {
      height: 40
    },
    src: logoBlanc,
    alt: "Ajuntament de Manresa"
  });
  var titol = props.titol || config.titol;
  var subtitol = props.subtitol || config.subtitol;
  var entorn = props.entorn || config.entorn;
  var newIcon = !!subtitol && config.showVersions && versState.isNewVersion && React.createElement(ChipNovaVersio, null);
  return React.createElement("div", null, React.createElement(core_1.AppBar, __assign({}, others, {
    style: {
      zIndex: 1400
    }
  }), React.createElement(core_1.Toolbar, null, leftButton, React.createElement("div", {
    style: {
      paddingLeft: 10
    }
  }, React.createElement(core_1.Typography, {
    variant: "h6",
    color: "inherit",
    noWrap: true,
    style: {
      lineHeight: '1em'
    }
  }, titol, " ", React.createElement(ChipEntorn, {
    entorn: entorn
  })), React.createElement(core_1.Typography, {
    variant: "body2",
    noWrap: true,
    component: "div"
  }, React.createElement("div", {
    onClick: handleClickSubtitol,
    style: {
      color: colorSubT,
      textDecoration: 'none',
      cursor: 'pointer'
    }
  }, subtitol, " ", newIcon))), React.createElement("div", {
    style: {
      flexGrow: 1
    }
  }), React.createElement(AppSessionInfo_1.default, null))), React.createElement(AppProgress_1.default, null));
};

exports.default = mobx_react_1.inject('appState')(mobx_react_1.observer(AppHeader));